import instance from './axiosInstance';

export function getPreDefinedMetricsMeta(reqBody = {}, http = instance) {
  return http.post('/metrics/pre-defined/meta', reqBody);
}

export function getUserDefinedMetricsMeta(
  reqBody: { context?: string; forceUpdate?: boolean } = {},
  http = instance,
) {
  const { context, forceUpdate = false } = reqBody;

  return http.post(`/metrics/user-defined/meta`, {
    forceUpdate,
    context,
  });
}

export function getFlowConfigMeta(
  reqBody: { context?: string; forceUpdate?: boolean } = {},
  http = instance,
) {
  const { context, forceUpdate = false } = reqBody;
  return http.post('/metrics/flow/meta', {
    forceUpdate,
    context,
  });
}

export function getFrustrationSignalConfigMeta(
  reqBody: { context?: string; forceUpdate?: boolean } = {},
  http = instance,
) {
  const { context, forceUpdate = false } = reqBody;

  return http.post(`/metrics/frustration-signal/meta`, {
    forceUpdate,
    context,
  });
}

export function getEventMetricsMeta(
  reqBody: { context?: string; forceUpdate?: boolean } = {},
  http = instance,
) {
  const { context, forceUpdate = false } = reqBody;
  return http.post('/metrics/event/meta', {
    forceUpdate,
    context,
  });
}

export function getDimensionsMeta(reqBody = {}, http = instance) {
  return http.post('/dimensions/meta', reqBody);
}
